export default "__VITE_ASSET__DAdYG7q$__"